/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RiskIDRequestBody,
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody$outboundSchema,
} from "../components/riskidrequestbody.js";

export type ArchiveSpendRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ArchiveSpendRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ArchiveSpendRuleSecurity = {
  option1?: ArchiveSpendRuleSecurityOption1 | undefined;
  option2?: ArchiveSpendRuleSecurityOption2 | undefined;
};

export type ArchiveSpendRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  riskIDRequestBody: RiskIDRequestBody;
};

/** @internal */
export type ArchiveSpendRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ArchiveSpendRuleSecurityOption1$outboundSchema: z.ZodMiniType<
  ArchiveSpendRuleSecurityOption1$Outbound,
  ArchiveSpendRuleSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function archiveSpendRuleSecurityOption1ToJSON(
  archiveSpendRuleSecurityOption1: ArchiveSpendRuleSecurityOption1,
): string {
  return JSON.stringify(
    ArchiveSpendRuleSecurityOption1$outboundSchema.parse(
      archiveSpendRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type ArchiveSpendRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ArchiveSpendRuleSecurityOption2$outboundSchema: z.ZodMiniType<
  ArchiveSpendRuleSecurityOption2$Outbound,
  ArchiveSpendRuleSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function archiveSpendRuleSecurityOption2ToJSON(
  archiveSpendRuleSecurityOption2: ArchiveSpendRuleSecurityOption2,
): string {
  return JSON.stringify(
    ArchiveSpendRuleSecurityOption2$outboundSchema.parse(
      archiveSpendRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type ArchiveSpendRuleSecurity$Outbound = {
  Option1?: ArchiveSpendRuleSecurityOption1$Outbound | undefined;
  Option2?: ArchiveSpendRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ArchiveSpendRuleSecurity$outboundSchema: z.ZodMiniType<
  ArchiveSpendRuleSecurity$Outbound,
  ArchiveSpendRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ArchiveSpendRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ArchiveSpendRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function archiveSpendRuleSecurityToJSON(
  archiveSpendRuleSecurity: ArchiveSpendRuleSecurity,
): string {
  return JSON.stringify(
    ArchiveSpendRuleSecurity$outboundSchema.parse(archiveSpendRuleSecurity),
  );
}

/** @internal */
export type ArchiveSpendRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RiskIDRequestBody: RiskIDRequestBody$Outbound;
};

/** @internal */
export const ArchiveSpendRuleRequest$outboundSchema: z.ZodMiniType<
  ArchiveSpendRuleRequest$Outbound,
  ArchiveSpendRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    riskIDRequestBody: RiskIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      riskIDRequestBody: "RiskIDRequestBody",
    });
  }),
);

export function archiveSpendRuleRequestToJSON(
  archiveSpendRuleRequest: ArchiveSpendRuleRequest,
): string {
  return JSON.stringify(
    ArchiveSpendRuleRequest$outboundSchema.parse(archiveSpendRuleRequest),
  );
}
